module.exports = __webpack_public_path__ + "img/arrow_back.fd73088d.svg";